import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StrapiTokenMap } from './token-replacer.service';

@Injectable({
  providedIn: 'root'
})
export class StrapiTokenStore {
  private readonly tokensSubject = new BehaviorSubject<StrapiTokenMap>({});

  readonly tokens$: Observable<StrapiTokenMap> = this.tokensSubject.asObservable();

  get tokens(): StrapiTokenMap {
    return this.tokensSubject.value;
  }

  setTokens(tokens: StrapiTokenMap): void {
    this.tokensSubject.next({ ...this.tokensSubject.value, ...tokens });
  }

  setToken(key: string, value: string | number | null): void {
    this.tokensSubject.next({ ...this.tokensSubject.value, [key]: value });
  }

  removeToken(key: string): void {
    const { [key]: _, ...rest } = this.tokensSubject.value;
    this.tokensSubject.next(rest);
  }

  clear(): void {
    this.tokensSubject.next({});
  }

  getToken(key: string): string | number | null | undefined {
    return this.tokensSubject.value[key];
  }
}
